import http from '@axios'
import {getUserToken, getUserData} from "@/helpers/Utils";

const endpoint = `/vehicle`;

const body = {
  "req": {
    "id": 123342523,
    "time": "2021-08-09T10:11:20+07:00",
    "src": "member-web",
    "op": ""
  },
  "data": {}
};

const addVehicle = (data) => {
  const user = getUserData();
  body.req.op = "addVehicle";
  body.req.uid = user.id;
  body.req.uname = user.username;
  body.req.token = getUserToken();
  body.data = data ;
  return http.post(endpoint, body);
}

const updateVehicle = (data) => {
  const user = getUserData();
  body.req.op = "updateVehicle";
  body.req.uid = user.id;
  body.req.uname = user.username;
  body.req.token = getUserToken();
  body.data = data ;
  return http.post(endpoint, body);
}

const listVehicle = (data) => {
  const user = getUserData();
  body.req.op = "listVehicle";
  body.req.uid = user.id;
  body.req.uname = user.username;
  body.req.token = getUserToken();
  body.data = data;
  return http.post(endpoint, body)
}

const lookupVehicle = (data) => {
  const user = getUserData();
  body.req.op = "lookupVehicle";
  body.req.uid = user.id;
  body.req.uname = user.username;
  body.req.token = getUserToken();
  body.data = data;
  return http.post(endpoint, body)
}

const activateVehicle = (data) => {
  const user = getUserData();
  body.req.op = "activateVehicle";
  body.req.uid = user.id;
  body.req.uname = user.username;
  body.req.token = getUserToken();
  body.data = data;
  return http.post(endpoint, body);
}

const setImgDoc = (data) => {
  const user = getUserData();
  body.req.op = "setImgDoc";
  body.req.uid = user.id;
  body.req.uname = user.username;
  body.req.token = getUserToken();
  body.data = data ;
  return http.post(endpoint, body);
}
export {addVehicle,lookupVehicle,listVehicle,updateVehicle, activateVehicle, setImgDoc }
